import { EventsCollection } from '@/firestoreDB'
import firebase from '@/plugins/firebase'
import 'firebase/analytics'
import store from '@/store'
import { isApp } from '@/utils/ReactNative'
import { apiCall } from '@/utils/api'

export const RegisterEvent = (nameEvent, setObject) => new Promise((resolve, reject) => {
  try {
    const result = RegisterEventAsync(nameEvent, setObject)
    resolve(result)
  } catch (error) {
    reject(error)
  }
})

export const RegisterEventAsync = async (nameEvent, setObject) => {
  const user = store.getters.firebaseUUID()
  const deviceInfo = store.getters.getDeviceInfo()
  let today = new Date().toLocaleString()
  const userData = {
    device_unique_id: deviceInfo.unique_id
      ? deviceInfo.unique_id
      : isApp
        ? 'unknown'
        : 'desktop',
    user_id: user,
    datetime: today,
    created_at: today,
    updated_at: today
  }
  await firebase.analytics().setUserId(user)
  await firebase.analytics().logEvent(nameEvent, {
    ...userData,
    ...setObject,
    action: nameEvent
  })

  const newPostRef = EventsCollection.push()
  newPostRef
    .set({
      ...userData,
      ...setObject,
      action: nameEvent
    })
    .then(() => {
      apiCall({
        url: '/api/v1.0/firebase/notify-event',
        data: {event_id: newPostRef.key},
        method: 'POST'
      })
    })
  return 'ok'
}



// WEBPACK FOOTER //
// ./src/analytics/index.js